<template>
    <div style="background-color: #fafafa;">
		<van-nav-bar title="线索" left-text="返回" left-arrow @click-left="onClickLeft" :z-index=998 fixed />
        <van-tabs class="tabs" v-model="selected" type="line" sticky @click="switchTab">
            <van-tab title="未分配"/>
            <van-tab title="已分配"/>
        </van-tabs>
        <van-search shape="round" v-model="value" placeholder="请输入搜索关键词" show-action @search="onSearch"
                    @cancel="onSearch">
            <div slot="action" @click="onSearch">搜索</div>
        </van-search>
		<van-dropdown-menu>
		  <van-dropdown-item v-model="sourceValue" :options="source" @change="changeSource"/>
		  <van-dropdown-item title="时间" class="dropdownItem" ref="item"> 
			  <div style="display: flex;height:100%;">
				  <van-sidebar v-model="activeKey" @change="changeSideBar">
				    <van-sidebar-item title="创建时间" />
				    <van-sidebar-item title="分配时间" />
				  </van-sidebar>
				  <date-filter v-if="showTime" :time-type="currDateType" @ongetdate="getDate"></date-filter>
			  </div>
		  </van-dropdown-item>
		</van-dropdown-menu>
        <select-staff :callback="assign" v-model="show"/>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list v-model="loading" :finished="finished" @load="onLoad" finished-text="没有更多了">
                <div v-for="(clue,index) in list" class="card" :key="clue.uuid" @click="openDetail(clue.uuid,clue.advisorId)">
                    <table class="layout">
                        <tr>
                            <td class="avatar-box" rowspan="4">
                                <img :src="avatarUrl + clue.advisorIdavatar" class="avatar" alt="avatar">
                                <p class="advisor">{{clue.advisorIdname}}</p>
                            </td>
                            <td colspan="2" >
                                <div class="header">
                                    <span class="title">{{clue.companyName}}</span>
									<van-tag v-if="type === 1">{{clue.statusname}}</van-tag>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" class="content">
                                <p>
                                    <span class="iconfont icon-user"/>
                                    <span>{{clue.contactPer || '无'}}</span>
                                </p>
                                <p>
                                    <span class="iconfont icon-call"/>
                                    <span>{{clue.mobile || '无'}}</span>
                                </p>
                                <p>
                                    <span class="iconfont icon-date"/>
                                    <span>{{clue.createTime}}</span>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
<!--                                <span class="icon iconfont icon-guanbi" @click="close(clue.uuid,$event)"/>-->
<!--                                <span class="icon iconfont icon-x" @click="del(clue.uuid,index,$event)"/>-->
<!--                                <span class="icon iconfont icon-chongxinfenpei" @click="selectUser(clue,$event)"/>-->
                                <van-icon name="phone-o" v-if="type===1" @click="call(clue.uuid,clue.mobile,$event)"/>
                            </td>

                        </tr>
                    </table>
                </div>
            </van-list>
        </van-pull-refresh>
    </div>
</template>

<script>
    import {Tab, Tabs, Panel, Button, List, Search, Popup,PullRefresh,Toast,NavBar,Tag,Col, Row ,Sidebar, SidebarItem,DatetimePicker,Field,DropdownMenu, DropdownItem, Icon} from 'vant';
    import userInfo from '../store/userInfo';
    import threadService from "../service/threadService";
    import moment from "moment";
    import {formatMoney} from "../utils/money";
    import {formatDictionary} from "../utils/dictionary";
	import fieldDescriptionService from "../service/fieldDescriptionService";
    import {API_URL} from "../common/config";
    import SelectStaff from "../components/SelectStaff";
	import ThreadDetails from "./ThreadDetails";
	import dateFilter from '../components/dateFilter';
	import dictionaryService from "../service/dictionaryService";

    export default {
        data: function () {
            return {
				detailShow:false,
                selected: 0,
				searchParam: {},
                list: [],
                loading: false,
                finished: false,
                pageIndex: 0,
                value: '',
                show: false,
                refreshing: false,
                type: 0,
                clueId:'',
				clue:{},
				showTime: true,
				activeKey: 0,
				contactTime: '',
				startContactTime: '',
				finishContactTime: '',
				createTime: '',
				startCreateTime: '',
				finishCreateTime: '',
				currDateType: 0,
				currCreateDateType: 0,
				currDisAdvisorDateType: 0,
				source: [{text:'全部渠道',value:0}],
				sourceValue: 0
				
            }
        },
        store: userInfo,
        components: {
			dateFilter,
            SelectStaff,
			ThreadDetails,
            [Tab.name]: Tab,
			[Tag.name]: Tag,
			[NavBar.name]: NavBar,
            [Tabs.name]: Tabs,
            [Button.name]: Button,
            [PullRefresh.name]: PullRefresh,
            [Panel.name]: Panel,
            [List.name]: List,
			[Col.name]: Col,
			[Row.name]: Row,
            [Search.name]: Search,
            [Popup.name]: Popup,
			[Sidebar.name]: Sidebar,
			[SidebarItem.name]: SidebarItem,
			[DatetimePicker.name]: DatetimePicker,
			[Field.name]: Field,
			[DropdownMenu.name]: DropdownMenu,
			[DropdownItem .name]: DropdownItem,
			[Icon .name]: Icon
        },
        computed: {
            userId() {
                return this.$store.getters.getUserId;
            },
            avatarUrl() {
                return API_URL + "/oa/common/attachment/showImage?id=";
            }
        },
        created: async function () {	
			this.searchParam = await fieldDescriptionService.getSearchParam("crm_clue");
			let resp = await threadService.getOptions('dict_customer_source');
			 if (resp.data.Status === "1") {
				 let source = resp.data.Data.map(item => {
                        return {text: item.name, value: item.uuid};
				});
				this.source = this.source.concat(source)
			 }
			 let tabIndex = localStorage.getItem('clueTabIndex');
			 if(tabIndex === undefined || tabIndex === null) {
			 	tabIndex = 0;
			 	this.selected = 0;
				this.type = 0;
			 }else {
			 	this.selected = parseInt(tabIndex);
				this.type = parseInt(tabIndex);
			 }
        },
        methods: {
			changeSideBar() {
				if(this.activeKey == 0) {
					this.currDateType = this.currCreateDateType
				}else {
					this.currDateType = this.currDisAdvisorDateType
				}
				this.showTime=false;
				var _this=this;
				this.$nextTick(function(){
					_this.showTime = true;
				})
			},
			getDate(data) {
				if(this.activeKey == 1) {
						this.startContactTime = data.startTime;
						this.finishContactTime = data.endTime;
						this.currDisAdvisorDateType = data.timeType;
		
				}else {
						this.startCreateTime = data.startTime;
						this.finishCreateTime = data.endTime;
						this.currCreateDateType = data.timeType;
				}
				 this.$refs.item.toggle();
				this.onSearch();
			},
			changeSource(value) {
				this.searchParam['searchField_dictionary_source'] = value;
				this.onSearch();
			},
            async onLoad() {
                this.pageIndex++;
				let tabIndex = localStorage.getItem('clueTabIndex');
				if(tabIndex === undefined || tabIndex === null) {
					tabIndex = 0;
					this.type = 0;
				}else {
					this.type = parseInt(tabIndex);
				}
				let status = this.type === 0 ? 'unassigned' : 'assigned';
                let resp = await threadService.getList(this.pageIndex, this.value, status,this.searchParam,this.startContactTime,this.finishContactTime,this.startCreateTime,this.finishCreateTime,this.sourceValue);
                resp.data.Data.data.forEach(clue => {
                    clue.createTime = moment(clue.createTime).format('YYYY-MM-DD');
                    clue.amount = formatMoney(clue.expectMoney === undefined ? "" : clue.expectMoney);
                    clue.remark = clue.remark || '暂无备注';
                    clue.advisorId = clue.advisorId === undefined ? clue.creatorId  : clue.advisorId ;
                });
                formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
                this.loading = false;
                this.refreshing = false;
				formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
                this.list = [...this.list, ...resp.data.Data.data];
                this.finished = resp.data.Data.total <= this.list.length;
            },
            onSearch() {
                this.finished = false;
                this.loading = true;
                this.pageIndex = 0;
                this.list = [];
                this.onLoad();
            },
            onRefresh() {
                this.finished = false;
                this.pageIndex = 0;
                this.list = [];
                this.onLoad();
            },
            openDetail(id,advisorId){
				this.$router.push({path:"ThreadDetails",query:{clueId:id,type:this.type}})
            },
            async del(id,index,e){
                e.stopPropagation();
                let resp = await threadService.del(id);
                if (resp.data.Status === '1') {
                    Toast.success('操作成功');
                    this.list.splice(index, 1);
                } else {
                    Toast.fail(resp.data.Message);
                }
            },
            async close(id,e){
                e.stopPropagation();
                let resp = await threadService.close(id);
                if (resp.data.Status === '1') {
                    Toast.success('操作成功');
                    this.onSearch();
                } else {
                    Toast.fail(resp.data.Data);
                }
            },
            async selectUser(clue, e){
                e.stopPropagation();
                if (clue.status === "6") {
                    Toast.fail('该线索已转化为商机');
                    return false;
                }
                this.show = true;
                this.clueId = clue.uuid;
            },
            async assign(staffId){
                let staffIds = localStorage.getItem("staffIds");
                if (staffIds === undefined || staffIds === null){
                    localStorage.setItem("staffIds",staffId);
                }else {
                    if (staffIds.split(staffId).length === 1){
                        staffIds = staffIds+","+staffId;
                        localStorage.setItem("staffIds",staffIds);
                    }
                }

                let resp = await threadService.assign(staffId,this.clueId);
                if (resp.data.Status === '1') {
                    Toast.success('分配成功');
                    this.show = false;
                    this.onRefresh();
                } else {
                    Toast.fail(resp.data.Data);
                }
            },
            async transfer(clue,e){
                e.stopPropagation();
                if(clue.status === '1'){
                    Toast.fail('该线索未分配,不可转化');
                    return false;
                }
                if(clue.status === '3'){
                    Toast.fail('该线索已关闭,不可转化');
                    return false;
                }
                if (clue.customerId) {
                    Toast.fail('该线索已转化为商机');
                    return false;
                }
                let resp = await threadService.translate(clue.uuid);
                if (resp.data.Status === '1') {
                    Toast.success('操作成功');
                    this.onSearch();
                } else {
                    Toast.fail(resp.data.Data);
                }
            },
            async call(uuid,mobile, e) {
                e.stopPropagation();
                let resp = await threadService.updateClueStatus(uuid,8);
                if (resp.data.Status === '1') {
                    window.location.href = 'tel:' + mobile;
                }
            },
            switchTab(tabIndex) {
				localStorage.setItem('clueTabIndex', tabIndex);
                window.scrollTo(0, 0);
                this.type = tabIndex;
				this.value = '';
                this.onSearch();
            },
			onClickLeft() {
			    window.open('/colseWebView');
			},
			closePopup() {
				this.detailShow = false;
			}
        }
    };

</script>

<style>
	.dropdownItem>.van-dropdown-item>.van-popup {
		max-height: 100%;
		height: 100%;
	}
    .van-popup--right{
        width:100%;
        height:100%;
    }
	.van-nav-bar {
		z-index: 99999;
	}
	.tabs {
	        margin-top: 120px;
	    }

    .van-icon {
        margin-right: 0.6rem;
        color: #4090FA;
    }

    .icon {
        margin-left: 1rem;
    }
</style>
